/*
 * Copyright 2020 The Backstage Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import React from 'react';
import {UserSettingsGeneral} from './General';
import { UserSettingsDefault } from './General/UserSettingDefault';
import {Header} from './Header';
import {useUserProfile} from './useUserProfileInfo';
import {Box} from '@material-ui/core';
import { TabbedLayout } from '@backstage/core-components';

export const SettingsPage = () => {  
  const { displayName } = useUserProfile(); 
  return (
    <>
      <Header
        title={`Welcome, ${displayName}`}
        subtitle="Manage your settings to make the Chofer Cloud Portal work better for you"
      />
      <TabbedLayout>
        <TabbedLayout.Route path="/profile" title="Profile" >
          <Box m={2}>
            <UserSettingsGeneral />
          </Box>
        </TabbedLayout.Route>
        <TabbedLayout.Route path="/user-defaults" title="Set Chofer Defaults">
          <Box m={2}>
            <UserSettingsDefault /> 
          </Box>
        </TabbedLayout.Route>
      </TabbedLayout>
    </>
  );
};
